/* src/app/forms/wizard-configuracao/wizard-configuracao.component.scss */
b {
  margin-right: 12px;
}
.mat-mdc-tab-body.mat-tab-body-active {
  height: 100%;
}
.block {
  animation: 1s fadeIn;
  animation-fill-mode: forwards;
  opacity: 0;
  animation: fadeIn 10s;
  animation-delay: 40s;
  animation-fill-mode: forwards;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.second-view {
  width: 100%;
  height: 100%;
}
.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.mktplace {
  overflow: auto;
  height: 100%;
}
.view-component {
  border: 1px solid rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
  margin: 0px;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}
.gridclass {
  height: 100%;
  width: 100%;
  position: absolute;
}
.mat-tab-body-content {
  height: auto !important;
}
.tabcontent {
  height: 100%;
  overflow-y: auto;
}
.cardcontent {
  height: 25%;
}
.mat-mdc-tab-group {
  height: 100%;
}
:host ::ng-deep .custom-tabs {
}
:host ::ng-deep .custom-tabs .mat-tab-body-wrapper {
  height: 100%;
}
.jumbo {
  align-items: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 6px;
}
.stepper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.div1 {
  font-size: 130%;
  width: 100%;
  height: 100%;
  gap: 10px;
  display: flex;
  flex-direction: column;
}
.title {
  width: 100%;
  padding: 6px;
  text-align: right;
  font-size: 100%;
}
.transformimage {
  transform: scale(1.5);
}
.mat-mdc-form-field {
  width: 100%;
}
:host ::ng-deep .mat-horizontal-content-container {
  height: 100%;
  overflow: auto;
  padding: 0 24px 10px 24px;
  display: flex;
}
.maincontent {
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
details {
  border: 1px solid #aaa;
  border-radius: 4px;
  padding: 0.5em 0.5em 0;
}
summary {
  font-weight: bold;
  margin: -0.5em -0.5em 0;
  padding: 0.5em;
}
summary:before {
  content: "";
  border-width: 0.4rem;
  border-style: solid;
  border-color: transparent transparent transparent #fff;
  position: absolute;
  top: 1.3rem;
  left: 1rem;
  transform: rotate(0);
  transform-origin: 0.2rem 50%;
  transition: 0.25s transform ease;
}
.buttonLayout {
  margin-top: 12px;
}
.buttonLayoutSave {
  margin-top: 12px;
  float: right;
}
.lista {
  margin: 15px;
}
:host ::ng-deep {
}
:host ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0px !important;
}
mat-grid-tile span {
  font-size: 12px;
  padding: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.more-options {
  padding-top: 4px;
  padding-bottom: 4px;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  align-items: center;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.mat-mdc-card-header {
  flex-direction: column;
}
/*# sourceMappingURL=wizard-configuracao.component.css.map */
